<template>
  <div class="form-params">
    <div class="form-params__btns">
      <slot />
    </div>
    <b-tabs>
      <b-tab
        :title="i18n('field')"
        :active="tabActive === 1"
      >
        <div class="form-params-content">
          <my-form
            ref="fieldOptionFormRef"
            :data="fieldOptionFormClone"
            :loading="fieldOptionLoading"
            :option="{columns:fieldOption || []}"
            :footer-visible="false"
            width="auto"
            @change="fieldChange"
          >
            <template
              slot="dictDataForm"
            >
              <div class="dict-data-content">
                <div
                  v-for="(item, i) in formOption.dictData"
                  :key="i"
                  class="dict-data-content__item"
                >
                  <b-form-input
                    v-model="formOption.dictData[i].label"
                    type="text"
                    class="d-inline-block"
                  />
                  <b-button
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click.stop="dictDataDelete(i)"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </div>
                <b-button
                  variant="outline-primary"
                  class="btn-icon rounded-circle"
                  size="sm"
                  @click.stop="dictDataAdd()"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
              </div>
            </template>
          </my-form>
        </div>
      </b-tab>
      <b-tab
        :title="i18n('common')"
        :active="tabActive === 2"
      >
        <div class="form-params-content">
          <my-form
            ref="commonOptionFormRef"
            :data="commonOptionForm"
            :loading="commonOptionLoading"
            :option="{columns:commonOption || []}"
            :footer-visible="false"
            width="auto"
            @change="commonChange"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTab, BTabs, BFormInput, BButton,
} from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue'
import componentsData from '@/components/components/customComponents'
import { flattenArray } from '@/components/components/utils'
import { deepClone } from '@/util/util'

export default {
  components: {
    BTab,
    BTabs,
    MyForm,
    BFormInput,
    BButton,
  },
  props: {
    fieldOptionForm: {
      type: Object,
      default: () => {},
    },
    commonData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      componentsData,
      fieldOptionLoading: false,
      commonOptionLoading: false,
      typeDict: [],
      multipleTypes: ['staff', 'worker'],
      dcitTypes: ['select', 'radio', 'check', 'checkbox'],
      hasMaxTypes: ['number', 'slider', 'upload'],
      hasMinTypes: ['number', 'slider'],
      defaultValueHideTypes: ['upload', 'table'],
      tabActive: 1,
      formOption: {},
    }
  },
  computed: {
    commonOption() {
      const columns = [
        {
          label: this.i18n('labelManage.formName'),
          field: 'formName',
          formOption: {
            type: 'input',
            rules: 'required',
          },
        },
        // {
        //   label: this.i18n('displaySaveButton'),
        //   field: 'displaySaveButton',
        //   formOption: {
        //     type: 'switch',
        //   },
        // },
        // {
        //   label: this.i18n('saveButtonText'),
        //   field: 'saveButtonText',
        //   formOption: {
        //     hide: !this.commonOptionForm.displaySaveButton,
        //     value: this.i18nBtns('save'),
        //   },
        // },
        // {
        //   label: this.i18n('displayClearButton'),
        //   field: 'displayClearButton',
        //   formOption: {
        //     type: 'switch',
        //   },
        // },
        // {
        //   label: this.i18n('clearButtonText'),
        //   field: 'clearButtonText',
        //   formOption: {
        //     hide: !this.commonOptionForm.displayClearButton,
        //     value: this.i18nBtns('reset'),
        //   },
        // },
      ]
      return columns
    },
    fieldOption() {
      const columns = [
        {
          label: this.i18n('label'),
          field: 'label',
          bind: 'label',
          formOption: {
            type: 'input',
          },
        },
        {
          label: this.i18n('type'),
          field: 'type',
          bind: 'formOption.type',
          formOption: {
            type: 'select',
            dictData: this.typeDict,
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('dictCodeOrDictData'),
          field: 'dictCodeOrDictData',
          bind: 'formOption.dictCodeOrDictData',
          formOption: {
            type: 'radio',
            value: this.formOption.dictData ? '0' : '1',
            dictData: [
              {
                label: 'Default Dictionary',
                value: '1',
              },
              {
                label: 'Custom Dictionary',
                value: '0',
              },
            ],
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('dictCode'),
          field: 'dictBizCode',
          bind: 'formOption.dictBizCode',
          formOption: {
            type: 'select',
            dictCode: 'dictBiz',
            hide: (this.dcitTypes.indexOf(this.formOption.type) === -1 || this.formOption.dictCodeOrDictData === '0'),
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('dictData'),
          field: 'dictData',
          bind: 'formOption.dictData',
          formOption: {
            slot: true,
            hide: (this.formOption.dictCodeOrDictData === '1'),
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('max'),
          field: 'numberMax',
          bind: 'formOption.numberMax',
          formOption: {
            type: 'number',
            hide: (this.hasMaxTypes.indexOf(this.formOption.type) === -1),
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('min'),
          field: 'numberMin',
          bind: 'formOption.numberMin',
          formOption: {
            type: 'number',
            hide: (this.hasMinTypes.indexOf(this.formOption.type) === -1),
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('multiple'),
          field: 'multiple',
          bind: 'formOption.multiple',
          formOption: {
            type: 'switch',
            hide: (this.formOption.type !== 'select' || this.multipleTypes.indexOf(this.formOption.dictCode) === -1),
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('placeholder'),
          field: 'placeholder',
          bind: 'formOption.placeholder',
          formOption: {
            type: 'input',
          },
        },
        {
          label: this.i18n('validation'),
          field: 'rules',
          bind: 'formOption.rules',
          formOption: {
            type: 'radio',
            dictData: [
              {
                label: 'Required',
                value: 'required',
              },
              {
                label: 'Not Required',
                value: '1',
              },
            ],
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('defaultValue'),
          field: 'value',
          bind: 'formOption.value',
          formOption: {
            updateNow: true,
            type: this.formOption.type,
            dictCode: this.formOption.dictCode,
            dictBizCode: this.formOption.dictBizCode,
            dictData: this.formOption.dictData,
            multiple: this.formOption.multiple,
            numberMax: this.formOption.numberMax,
            numberMin: this.formOption.numberMin,
            hide: (this.defaultValueHideTypes.indexOf(this.formOption.type) !== -1) || !!this.funcValue,
            disabled: this.formOption.formEditDisabled,
          },
        },
        {
          label: this.i18n('span'),
          field: 'span',
          bind: 'formOption.span',
          formOption: {
            type: 'slider',
            numberMax: 12,
            numberMin: 1,
          },
        },
        {
          label: this.i18n('tableShow'),
          field: 'tableShow',
          bind: 'formOption.tableShow',
          formOption: {
            type: 'radio',
            dictData: [
              {
                label: 'Show',
                value: true,
              },
              {
                label: 'Not Show',
                value: false,
              },
            ],
          },
        },
        {
          label: this.i18n('search'),
          field: 'search',
          bind: 'search',
          formOption: {
            type: 'radio',
            dictData: [
              {
                label: 'YES',
                value: true,
              },
              {
                label: 'NO',
                value: false,
              },
            ],
          },
        },
      ]
      return columns
    },
    fieldOptionFormClone() {
      const temp = deepClone(this.fieldOptionForm) || {}
      return temp
    },
    commonOptionForm() {
      const temp = deepClone(this.commonData) || {}
      return temp
    },
    funcValue() {
      return this.fieldOptionFormClone.funcValue
    },
  },
  watch: {
    'fieldOptionFormClone.formOption': {
      handler(e) {
        console.log(this.formOption, 'cahnge');
        this.formOption = e
      },
      deep: true,
      immediate: true,
    },
    formOption: {
      handler(e) {
        if (e.dictCodeOrDictData === '0' && !e.dictData) {
          this.formOption.dictData = []
          this.formOption.dictCode = ''
          this.$forceUpdate()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    console.log(this.fieldOptionForm, 'asdada');
    const array = flattenArray(this.componentsData, 'label', 'formOption.type', 'items') || []
    const filterArray = []
    array.forEach(item => {
      if (item.formOption && (!item.formOption.dictCode || !item.formOption.type)) {
        if (item.formOption.type) {
          filterArray.push({
            label: item.label,
            value: item.formOption.type,
          })
        }
      }
    })
    this.typeDict = filterArray
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_formCustom.${param}`)
    },
    i18nBtns(param) {
      return this.$t(`_components.btns.${param}`)
    },
    fieldChange(e) {
      if (e.field) {
        this.formOption = e.formOption
        this.$emit('change', e)
      }
    },
    commonChange(e) {
      // console.log(e, this.commonOptionForm, 'change');
    },
    async validationForm() {
      const params = await this.$refs.commonOptionFormRef.validationForm()
      if (params) {
        return params
      }
      this.tabActive = 2
      return false
    },
    dictDataDelete(index) {
      this.formOption.dictData.splice(index, 1)
    },
    dictDataAdd() {
      this.formOption.dictData.push(
        {
          label: '',
          value: String(this.formOption.dictData.length + 1),
        },
      )
      this.$forceUpdate()
    },
  },
}

</script>

<style lang='scss' scoped>
.form-params{
  position: relative;
  &-content{
    padding: 0 10px;
    height: 70vh;
    overflow: auto;
  }
  &__btns{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 9;
  }
}
.form-slider{
  width: 100%;
  padding: 0 30px
}
</style>
<style lang="scss">
.form-params{
  .my-form{
    padding: 0 !important;
  }
  .dict-data-content{
    &__item{
      margin-bottom: 5px;
      input{
        width: 85%;
      }
      button{
        margin-left: 5px;
      }
    }
  }
}
</style>
